<template>
<span>
  <v-subheader>{{result.name}}</v-subheader>
    <v-list-item
        color="blue"
        v-for="item in result.items"
        :key="item.id"
        class="mb-2 text-decoration-none"
        :to="`/inventory/?tab=stock&item_id=${item.uuid}`"
    >

        <v-list-item-avatar rounded="lg" size="50" color="blue lighten-5">
            <v-icon color="blue darken-1">mdi-counter</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{item.description}}</v-list-item-title>
          <v-list-item-title>Created At:{{ item.created_at | humanDate }}</v-list-item-title>
          <v-list-item-title>Created By:{{ item.user_name }}</v-list-item-title>
                </v-list-item-content>
        <v-list-item-action-text>
          <v-icon color="grey lighten-2" small>mdi-chevron-right</v-icon>
        </v-list-item-action-text>
      </v-list-item>

</span>

</template>
<script>
export default {
  name: "StockTaking",
  props:{
    result:{
      type:Object
    }
  }
}
</script>

<style scoped>

</style>